var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [_vm._v(_vm._s(_vm.$t("ContinuousReport.TabInfo.Monthly")))]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(
        _vm._s(_vm.$t("ContinuousReport.TargetGroupsAndOperation.TargetGroup"))
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t("ContinuousReport.TargetGroupsAndOperation.IsOrganisation")
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Title"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.OperationType"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Description"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Targets"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-0" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Targets_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.OperationCount"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-0" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.OperationCount_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.CollectionMethod"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.RealizedCount"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-0" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.RealizedCount_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.EncounterCount"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-0" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.EncounterCount_Instructions"
              )
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.CouncelingDescription"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.CouncelingDescription_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.TargetGroupsAndOperation.Distribution.DistributionHeading"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.TargetGroupsAndOperation.Distribution.DistributionHeading_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.TargetGroupsAndOperation.Distribution.PeopleTurnover"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReport.TargetGroupsAndOperation.Distribution.PeopleTurnover_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("ContinuousReport.Notes.TargetGroupsAndOperation")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("ContinuousReport.Notes.TargetGroupsAndOperation_Instructions")
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }